export default {
  AccountHeldError__ERROR: `Your account is in a held status and cannot be accessed. For information on how to resolve, visit`,
  AccountHeldError__LINK: (options) => `southwest.com${options.link}`,
};
